import gql from 'graphql-tag';
// import { GQL } from '@gin-betting/core';

// export type GetSportEventIdsByFiltersQuery = {
//     matches: Array<{
//         id: string;
//         fixture: {
//             type: GQL.SportEventType;
//         };
//     }>;
// };

export default gql`
    query GetSportEventIdsByFilters(
        $sportEventIds: [String!]!
        $offset: Int
        $limit: Int
        $searchString: String
        $dateFrom: String
        $dateTo: String
        $dateSortAscending: Boolean
        $providerIds: [Int!]
        $matchStatuses: [SportEventStatus!]
        $marketStatuses: [MarketStatus!]
        $sportIds: [String!]
        $tournamentIds: [String!]
        $sportEventTypes: [SportEventType!]
        $marketTypes: [Int!]
    ) {
        matches: filterSportEvents(
            sportEventIds: $sportEventIds
            offset: $offset
            limit: $limit
            searchString: $searchString
            dateFrom: $dateFrom
            dateTo: $dateTo
            dateSortAscending: $dateSortAscending
            providerIds: $providerIds
            matchStatuses: $matchStatuses
            marketStatuses: $marketStatuses
            sportIds: $sportIds
            tournamentIds: $tournamentIds
            sportEventTypes: $sportEventTypes
            marketTypes: $marketTypes
        ) {
            id
            fixture {
                type
            }
        }
    }
`;
